import script from "./ElMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ElMenu.vue?vue&type=script&setup=true&lang=js"

import "./ElMenu.vue?vue&type=style&index=0&id=2ea2c6bc&scoped=true&lang=scss"
import "./ElMenu.vue?vue&type=style&index=1&id=2ea2c6bc&lang=scss"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea2c6bc"]])

export default __exports__